import { createFileRoute } from "@tanstack/react-router";
import { LiveAdminPage } from "@/components/shared/LiveAdminPage";
export const Route = createFileRoute("/admin.schedule")({ component: Page });
function Page() {
  return (
    <LiveAdminPage
      title="Schedule"
      description="Scheduled service visits."
      table="service_tickets"
      columns={[
        { key: "ticket_number", label: "Ticket" },
        { key: "scheduled_start", label: "Start" },
        { key: "scheduled_end", label: "End" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
